import { FilterConfig, User } from '@hakimo-ui/hakimo/types';
import { ANALYZING_DEFAULT_STATUS_TENANTS, filterConfigs } from './constants';
import {
  AlarmListFilterValues,
  AlarmListFilterValuesWithoutTenant,
  FilterValues,
} from './types';

const hasAnalyzingDefaultStatus = (user: User | null | undefined) =>
  !!user?.tenant?.id &&
  ANALYZING_DEFAULT_STATUS_TENANTS.includes(user.tenant.id);

export const getFilterConfigs = (
  canViewTenantColumn: boolean,
  user: User | null | undefined
) =>
  filterConfigs
    .filter((config) => {
      if (config.type === 'tenant' && !canViewTenantColumn) {
        return false;
      }
      if (
        config.type === 'type' &&
        user?.alarm_types &&
        user?.alarm_types?.length > 0
      ) {
        return false;
      }
      return true;
    })
    .map((config): FilterConfig => {
      if (config.type === 'status' && hasAnalyzingDefaultStatus(user)) {
        return {
          ...config,
          defaultValue: {
            values: ['Analyzing'],
            negative: false,
          },
        };
      }
      return config;
    });

export const defaultFilterValues = (
  canViewTenantColumn: boolean,
  user: User | null | undefined
) => {
  const configs = getFilterConfigs(canViewTenantColumn, user);

  return configs.reduce((acc, config) => {
    return { ...acc, [config.type]: config.defaultValue };
  }, {} as AlarmListFilterValues | AlarmListFilterValuesWithoutTenant);
};

export const patchFilterValues = (
  filterValues: FilterValues,
  canViewTenantColumn: boolean,
  user: User | null | undefined
) => {
  const defFilterValues = defaultFilterValues(canViewTenantColumn, user);

  return (
    Object.keys(defFilterValues) as Array<keyof typeof defFilterValues>
  ).reduce((acc, key) => {
    return { ...acc, [key]: filterValues[key] || defFilterValues[key] };
  }, {} as FilterValues);
};

export const getResetDefaultFilterValues = (
  canViewTenantColumn: boolean,
  user: User | null | undefined
) => {
  const configs = getFilterConfigs(canViewTenantColumn, user);
  const resetValues = configs.reduce((acc, config) => {
    return { ...acc, [config.type]: config.defaultValue };
  }, {} as FilterValues);

  if (user?.alarm_types && user.alarm_types.length > 0) {
    resetValues.type = {
      values: user.alarm_types.map((at) => ({
        id: at.id,
        name: at.type,
      })),
      negative: false,
    };
  }
  if (
    user?.default_alarm_status_list &&
    user.default_alarm_status_list.length > 0
  ) {
    resetValues.status = {
      values: user.default_alarm_status_list as any[],
      negative: false,
    };
  }

  return resetValues;
};
